<template>
	<div>
		<j-card class="bg5 p2">
			<!-- Dynamic fields -->
			<div
				class="flex wrap xs-top xs-12 pl4 pr4 lg-pr0 mt2 mb6 lg-mb2"
				v-for="(item, i) in commissionSplit"
				:key="i"
			>
				<!-- Select user or organization -->
				<div class="xs-12 pr2 fw7 fs3 c6 pb2">{{ $t(item.remark) }}</div>
				<div class="flex wrap xs-12 lg-4 pr1 xs-middle mb1 lg-mb0">
					<div class="xs">
						<!-- If no id, show options to select what to add - organization vs internal -->
						<div
							v-if="!(item.person && item.person.length && item.person[0].id)"
							class="fs3 p2 bg4 r1 lh125"
						>
							<!-- Select organization or internal -->
							{{ $t("commission_for") }}
							<j-button
								size="small"
								type="tertiary"
								@click="
									item.organizationOrInternal = 'organization'
									item.person = []
								"
							>{{ $t("organization") }}</j-button>
							{{ $t("or") }}
							<j-button
								size="small"
								type="tertiary"
								@click="
									item.organizationOrInternal = 'internal'
									item.person = []
								"
							>{{ $t("participant") }}</j-button>
						</div>

						<!-- TODO: IT;s bit hacky, we had to tweak quickly for Asia Insurance -->
						<!-- What thi does is if commission is already assigned and it's for organization 
						it shows core-select-organizations. If nothing was assigned yet and user is in the process 
						of creation of commission rule and he picked organizationOrInternal as organization, it shows core-select-organizations 
						The same applies for internals.-->
						<core-select-organizations
							v-if="
								(item.person.length === 0 &&
									item.organizationOrInternal === 'organization') ||
									(item.person[0] &&
										item.person[0].__typename === 'organization')
							"
							size="small"
							v-model="item.person"
							@input="item.id ? updateRule(item.id) : addRule(item)"
						/>
						<core-select-internals
							v-if="
								(item.person.length === 0 &&
									item.organizationOrInternal === 'internal') ||
									(item.person[0] && item.person[0].__typename === 'internal')
							"
							size="small"
							v-model="item.person"
							@input="item.id ? updateRule(item.id) : addRule(item)"
						/>
					</div>
				</div>

				<!-- Rule type selection -->
				<div class="xs-12 lg-4 mb1 lg-mb0">
					<j-base-select
						size="small"
						:options="ruleOptions"
						v-model="item.ruleType"
						@input="
							item.value = null
							item.basedOnRuleId = null
							item.id ? updateRule(item.id) : addRule(item)
						"
						:placeholder="`-- ${$t('select_type')}`"
					/>
				</div>

				<!-- Flat -->
				<div class="xs-11 lg-3 flex mb1 lg-mb0" v-if="item.ruleType === 'flat'">
					<div class="xs-6 lg-pl1">
						<j-base-input-number
							type="float"
							size="small"
							v-model="item.value"
							@blur="item.id ? updateRule(item.id) : addRule(item)"
							:placeholder="$t('amount')"
						/>
					</div>
					<div class="xs-6 pl1">
						<crm-select-currency
							size="small"
							v-model="item.currencyCode"
							@input="item.id ? updateRule(item.id) : addRule(item)"
							:placeholder="$t('currency')"
						/>
					</div>
				</div>

				<!-- Ratio on premium -->
				<div
					class="xs-11 lg-3 flex mb1 lg-mb0"
					v-else-if="item.ruleType === 'ratio'"
				>
					<div class="flex xs-12 lg-pl1 xs-middle">
						<j-base-input-number
							size="small"
							:min="0"
							:max="100"
							v-model="item.value"
							@blur="item.id ? updateRule(item.id) : addRule(item)"
							:placeholder="$t('%_of_premium')"
						/>
						<span class="pl1">%</span>
					</div>
				</div>

				<!-- Ratio on rule -->
				<div
					class="xs-11 lg-3 flex mb1 lg-mb0"
					v-if="item.ruleType === 'ratioBasedOnOtherRule'"
				>
					<div class="xs-7 lg-pl1">
						<j-base-select
							size="small"
							:options="getOptionsForRuleSelection(i)"
							v-model="item.basedOnRuleId"
							@input="item.id ? updateRule(item.id) : addRule(item)"
							:placeholder="`-- ${$t('rule')}`"
							:allowSelectNothing="false"
						/>
					</div>
					<div class="flex xs-5 pl1 xs-middle">
						<j-base-input-number
							size="small"
							:min="0"
							:max="100"
							v-model="item.value"
							@blur="item.id ? updateRule(item.id) : addRule(item)"
							placeholder="%"
						/>
						<span class="pl1">%</span>
					</div>
				</div>

				<!-- Delete -->
				<div v-if="item.id" class="flex xs-1 xs-middle xs-center pt2">
					<crm-icon
						name="delete"
						class="cu2"
						color="cError"
						@click.native="removeRule(i)"
					/>
				</div>
			</div>

			<!-- Message -->
			<div class="pl4 pr4 mb2" v-if="message" @click.native="message = null">
				<div class="p2 ta2 c5 fs3" :class="message.class">{{ message.text }}</div>
			</div>

			<!-- Commissions Summary -->
			<div
				v-if="!hideSummary && offer && offer.commissionSummary.length > 0"
				class="xs-12 p4"
			>
				<!-- Headline -->
				<div class="xs-12fw7 fs4 mb2 mt6 c6">Summary:</div>
				<!-- Summary -->
				<div
					class="flex xs-12 xs-between pt4 pb4"
					v-for="(item, i) in offer.commissionSummary"
					:key="i"
				>
					<div class="xs-4 ta1">{{ item.entity ? item.entity.name : "---" }}</div>
					<div class="xs-4 ta2">
						{{ parseFloat((item.ratio * 100).toFixed(6)) }}%
						{{ $t("of_premium") }}
					</div>
					<div class="xs-4 ta3 fw7">
						{{
						item.currencyCode && item.currencyCode !== "UNDEFINED"
						? item.currencyCode
						: ""
						}}
						{{ item.amount }}
					</div>
				</div>
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import JBaseInputNumber from "@/components/JBaseInputNumber/"
import JBaseSelect from "@/components/JBaseSelect/"
import CoreSelectInternals from "@/modules/core/components/CoreSelectInternals"
import CoreSelectOrganizations from "@/modules/core/components/CoreSelectOrganizations"
import CrmIcon from "@/components/CrmIcon/"

// TODO: refactor to core currency or have it hardcoded for a tenant as currency option via prop?
import CrmSelectCurrency from "@/components/CrmSelectCurrency/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const presetCommissionSplit = [
	{
		remark: "coverholder",
		person: [],
		value: 0
	},
	{
		remark: "agency",
		person: [],
		value: 0
	},
	{
		remark: "thirdParty",
		person: [],
		value: 0
	},
	{
		remark: "broker",
		person: [],
		value: 0
	},
	{
		remark: "salesman",
		person: [],
		value: 0
	}
]

export default {
	components: {
		JCard,
		JButton,
		CrmIcon,
		CrmSelectCurrency,
		CoreSelectInternals,
		CoreSelectOrganizations,
		JBaseSelect,
		JBaseInputNumber
	},

	props: {
		offer: Object
	},

	data() {
		return {
			message: null,
			timeout: null,
			commissionSplit: [],

			// hide summary
			hideSummary: true
		}
	},

	computed: {
		binderDefaultCommissionJsonRule() {
			return this.offer?.associatedContracts?.[0]?.contract?.commissionRule
				?.jsonRule
		},
		binderDefaultCommissionParty() {
			return this.offer?.associatedContracts?.[0]?.contract?.firstParty
		},
		ruleOptions() {
			let output = [
				{ name: this.$t("flat_fee"), value: "flat" },
				{ name: this.$t("%_of_premium"), value: "ratio" }
			]

			/*
			* TODO: Uncomment when this is fixed. The id of rules change when we create the policy, so these rules don't work
			*
			// If there is only one rule, don't allow to select "based on rule" ruleType
			if (this.commissionSplit.length > 1)
				output.push({
					name: this.$t("%_of_result_of_rule"),
					value: "ratioBasedOnOtherRule"
				})
			*/

			return output
		},

		caseId() {
			return this.$store.state.caseManagement.caseId
		},

		proposalId() {
			return this.$store.state.caseManagement.proposalId
		},

		offerId() {
			return this.$store.state.caseManagement.offerId
		}
	},

	methods: {
		getJsonRule(rule) {
			let jsonRule
			if (rule.ruleType === "ratio")
				jsonRule = `{ "*": [ {"var" : "totalPremium"}, ${
					rule.value ? parseInt(rule.value) / 100 : 0
				}]}`
			else if (rule.ruleType === "flat")
				jsonRule = `[${
					rule.value ? parseFloat(rule.value) : 0
				}, "${rule?.currencyCode ||
					this.$store?.state?.settings?.preferredCurrency ||
					"HKD"}"]`
			else if (rule.ruleType === "ratioBasedOnOtherRule")
				jsonRule = `{ "*": [ {"var" : "${rule.basedOnRuleId}"}, ${
					rule.value ? parseInt(rule.value) / 100 : 0
				} ]}`
			return jsonRule.replace(/\s/g, "")
		},

		async addRule(item) {
			// Process rule to API format
			const jsonRule = item.fromBinder
				? this.binderDefaultCommissionJsonRule
				: item.ruleType
				? this.getJsonRule(item)
				: '{ "*": [ {"var" : "totalPremium"}, 0 ]}'

			const entityId = item.fromBinder
				? this.binderDefaultCommissionParty.id
				: item?.person?.[0]?.id || null

			const query = gql`
				mutation addCommissionToOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: commissionInput!
				) {
					addCommissionToOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						input: $input
					) {
						status
						errors
					}
				}
			`

			// Add default rule to offer api call
			const { caseId, proposalId, offerId } = this
			const res = await api({
				query,
				variables: {
					caseId,
					proposalId,
					offerId,
					input: {
						entityId,
						remark: item.remark,
						jsonRule
					}
				}
			})

			// TODO: errors

			// console.log(
			// 	"TODO: handle errors - user should refresh to get latest correct state"
			// )
			if (res?.errors?.length) {
				this.addMessage(this.$t("errors.general"))
			}

			// Refetch all results
			this.$emit("input")
		},

		async updateRule(id) {
			const query = gql`
				mutation updateCommissionOfOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$id: String!
					$input: commissionInput!
				) {
					updateCommissionOfOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						id: $id
						input: $input
					) {
						status
						errors
					}
				}
			`

			// Process rule to API format
			const rule = this.commissionSplit.find(item => item.id === id)
			console.log(rule)
			let jsonRule
			if (rule.ruleType === "ratio")
				jsonRule = `{ "*": [ {"var" : "totalPremium"}, ${
					rule.value ? parseFloat(rule.value / 100) : 0
				} ]}`
			else if (rule.ruleType === "flat")
				jsonRule = `[${rule.value ? parseFloat(rule.value) : 0}, "${
					rule.currencyCode
				}"]`
			else if (rule.ruleType === "ratioBasedOnOtherRule")
				jsonRule = `{ "*": [ {"var" : "${rule.basedOnRuleId}"}, ${parseInt(
					rule.value
				) / 100} ]}`

			// Update api call
			const { caseId, proposalId, offerId } = this
			const res = await api({
				query,
				variables: {
					caseId,
					proposalId,
					offerId,
					id,
					input: {
						entityId: rule?.person?.[0]?.id || null,
						jsonRule
					}
				}
			})

			// Refetch
			this.$emit("input")
		},

		async removeRule(index) {
			const query = gql`
				mutation removeCommissionFromOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$id: String!
				) {
					removeCommissionFromOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						id: $id
					) {
						status
						errors
					}
				}
			`

			const isRuleDependency = index => {
				// Go through all rules and find if index of rule to be deleted is in some other rule
				return this.commissionSplit.some(
					item => item.basedOnRuleId && `${item.basedOnRuleId}` === `${index}`
				)
			}

			// Before removing, check whether the rule is dependency to some other rule
			// If it is, don't delete but show error
			if (!isRuleDependency(index)) {
				const ruleId = this.commissionSplit[index]
					? this.commissionSplit[index].id
					: null

				// Remove api call
				const { caseId, proposalId, offerId } = this
				const res = await api({
					query,
					variables: {
						caseId,
						proposalId,
						offerId,
						id: ruleId
					}
				})

				// Refetch all results
				this.$emit("input")
			} else this.addMessage(this.$t("errors.this_rule_cant_be_deleted"))
		},

		addMessage(message, type) {
			// Reset timeout
			// In case there is already some timeout running, it might remove new message early
			clearTimeout(this.timeout)

			const classMap = {
				error: "bgError",
				success: "bgSuccess",
				info: "bgInfo"
			}

			// Set message
			this.message = {
				text: message,
				class: classMap[type || "error"]
			}

			// Remove message after some time
			this.timeout = setTimeout(() => {
				this.message = null
			}, 5000)
		},

		getOptionsForRuleSelection(excludedIndex) {
			// Remove rule of excludedIndex, prevent infinit loop
			return this.commissionSplit
				.map((item, i) => ({
					name: this.$t(item.remark),
					value: item.id
				}))
				.filter((item, i) => `${i}` !== `${excludedIndex}`)
		}
	},
	watch: {
		offer: {
			handler(newOffer, oldOffer) {
				const getValue = rule => {
					if (rule.type === "ratio") {
						const jsonRule = JSON.parse(rule.jsonRule)
						const value = jsonRule["*"][1]
						return value ? parseFloat((value * 100).toFixed(3)) : 0
					} else if (rule.type === "flat") return rule.amount
					else if (
						rule.type === "ratioBasedOnOtherRule" &&
						rule.baseCommissionRatio &&
						rule.baseCommissionRatio.ratio
					)
						return (rule.baseCommissionRatio.ratio * 100).toFixed(0)
					else return 0
				}

				const getBaseIdFromJsonLogic = jsonRule => {
					let parsed = null
					try {
						parsed = JSON.parse(jsonRule)
					} catch (e) {
						console.error(e)
					}
					return parsed && parsed["*"] && parsed["*"][0]
						? parsed["*"][0].var
						: null
				}

				const getCommissionValues = offer => ({
					jsonRule:
						offer?.associatedContracts?.[0]?.contract?.commissionRule?.jsonRule,
					firstParty: offer?.associatedContracts?.[0]?.contract?.firstParty,
					appliedCommissionRule: offer?.commissionSplitRules?.find(
						rule => rule.remark === "coverholder"
					)?.jsonRule
				})

				this.commissionSplit =
					newOffer?.commissionSplitRules?.map(item => ({
						id: item.id,
						value: getValue(item),
						person: [
							{
								id: item?.entity?.id || null,
								name: item?.entity?.name || null,
								__typename: item?.entity?.__typename || null
							}
						],
						ruleType: item.type,
						currencyCode: item.currencyCode,
						remark: item.remark,
						basedOnRuleId:
							item.type === "ratioBasedOnOtherRule"
								? getBaseIdFromJsonLogic(item.jsonRule)
								: null
					})) || []

				// Complete this.commissionSplit using the preset values
				presetCommissionSplit.forEach(item => {
					if (
						!this.commissionSplit.find(
							commission => commission.remark === item.remark
						)
					) {
						this.commissionSplit.push(JSON.parse(JSON.stringify(item)))
					}
				})

				// Sort array and put 'coverholder' in first place
				this.commissionSplit.sort((a, b) => (a.remark > b.remark ? 1 : -1))

				const coverholder = this.commissionSplit.find(
					commission => commission.remark === "coverholder"
				)

				if (
					/* IF - offer is added with binder commission */
					!oldOffer &&
					getCommissionValues(newOffer).jsonRule &&
					getCommissionValues(newOffer).jsonRule !==
						getCommissionValues(newOffer).appliedCommissionRule &&
					!this.commissionSplit.find(item => item.remark === "coverholder").id
				) {
					this.addRule({
						...coverholder,
						fromBinder: true
					})
					// this.addMessage(
					// 	this.$t("default_binder_commission_added_to_offer"),
					// 	"success"
					// )
				} else if (
					/* OR- binder changes with new commission rule */
					oldOffer &&
					newOffer &&
					getCommissionValues(newOffer).jsonRule &&
					(getCommissionValues(oldOffer).jsonRule !==
						getCommissionValues(newOffer).jsonRule ||
						getCommissionValues(oldOffer).firstParty.id !==
							getCommissionValues(newOffer).firstParty.id)
				) {
					this.removeRule(
						this.commissionSplit.findIndex(
							item => item.remark === "coverholder"
						)
					)
					this.addRule({
						...coverholder,
						fromBinder: true
					})
					// this.addMessage(
					// 	this.$t("commission_updated_on_offer_from_default"),
					// 	"success"
					// )
				} else if (
					/* OR - remove commission if binder is removed */
					!getCommissionValues(newOffer).jsonRule &&
					getCommissionValues(oldOffer).jsonRule
					// && getCommissionValues(oldOffer).jsonRule === getCommissionValues(oldOffer).appliedCommissionRule
				) {
					this.removeRule(
						this.commissionSplit.findIndex(
							item => item.remark === "coverholder"
						)
					)
					// this.addMessage(
					// 	this.$t("default_commission_rule_removed_from_offer"),
					// 	"success"
					// )
				}
			},
			immediate: true
		}
	}
}
</script>
